import { render, staticRenderFns } from "./UserManagementOverview.vue?vue&type=template&id=10cb8cfe&scoped=true&"
import script from "./UserManagementOverview.vue?vue&type=script&lang=js&"
export * from "./UserManagementOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementOverview.vue?vue&type=style&index=0&id=10cb8cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb8cfe",
  null
  
)

/* custom blocks */
import block0 from "./UserManagementOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cb8cfe')) {
      api.createRecord('10cb8cfe', component.options)
    } else {
      api.reload('10cb8cfe', component.options)
    }
    module.hot.accept("./UserManagementOverview.vue?vue&type=template&id=10cb8cfe&scoped=true&", function () {
      api.rerender('10cb8cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user-management/UserManagementOverview.vue"
export default component.exports